module.exports = __webpack_public_path__ + "static/media/correct.5549796f.mp3";